/**
 * @generated SignedSource<<5b8a7381a2e38ebdb063aeaba3d0665f>>
 * @relayHash 28da4560342658d689d0d87c5815a0d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b47ba8a1b0ad06e2b600b65d5b910c1ba58523b843824cfd2cbca4489106555a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b47ba8a1b0ad06e2b600b65d5b910c1ba58523b843824cfd2cbca4489106555a",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
